export const titleCase = str => str.toLowerCase().replace(/\b\S/g, t => t.toUpperCase());



// WEBPACK FOOTER //
// ./client/utils/titleCase.js